import { GlLink, GlLoadingIcon, GlSprintf } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import Visibility from 'visibilityjs';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import { __, s__ } from '~/locale';
import { reportToSentry } from '~/ci/utils';
import { getIncreasedPollInterval } from '~/ci/utils/polling_utils';
import { NETWORK_STATUS_READY, PIPELINE_POLL_INTERVAL_DEFAULT } from '~/ci/constants';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import CiIcon from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/ci_icon/ci_icon.vue?vue3';
import TimeAgoTooltip from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/time_ago_tooltip.vue?vue3';
import { getQueryHeaders } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/pipeline_details/graph/utils.js?vue3';
import PipelineMiniGraph from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/pipeline_mini_graph/pipeline_mini_graph.vue?vue3';
import getPipelineSummaryQuery from './graphql/queries/get_pipeline_summary.query.graphql';
export default {
    name: 'PipelineSummary',
    i18n: {
        loadingText: s__('Pipeline|Checking pipeline status'),
        pipelineSummaryFetchError: __('There was a problem fetching the pipeline summary.'),
        pipelineStatusText: s__('Pipelines|Pipeline %{linkStart}#%{pipelineId}%{linkEnd} %{status}'),
        pipelineCommitText: s__('Pipelines|Pipeline %{status} for %{linkStart}%{commit}%{linkEnd} ')
    },
    components: {
        CiIcon,
        GlLink,
        GlLoadingIcon,
        GlSprintf,
        PipelineMiniGraph,
        TimeAgoTooltip
    },
    props: {
        fullPath: {
            type: String,
            required: true
        },
        iid: {
            type: String,
            required: true
        },
        includeCommitInfo: {
            type: Boolean,
            required: false,
            default: false
        },
        pipelineEtag: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            hasGraphQLError: false,
            pipeline: {},
            pollInterval: PIPELINE_POLL_INTERVAL_DEFAULT
        };
    },
    apollo: {
        pipeline: {
            context () {
                return getQueryHeaders(this.pipelineEtag);
            },
            query: getPipelineSummaryQuery,
            // Pipelines without an iid (e.g. some imported ones) cannot be queried,
            // and the server would reject the request for the missing required variable.
            skip () {
                return !this.iid;
            },
            notifyOnNetworkStatusChange: true,
            pollInterval () {
                return this.pollInterval;
            },
            variables () {
                return {
                    fullPath: this.fullPath,
                    iid: this.iid,
                    includeCommitInfo: this.includeCommitInfo
                };
            },
            result ({ networkStatus }) {
                // We need this for handling the reactive poll interval while also using frontend cache
                // a status of 7 = 'ready'
                if (networkStatus !== NETWORK_STATUS_READY) return;
                this.pollInterval = this.increasePollInterval();
            },
            update ({ project }) {
                return project?.pipeline || {};
            },
            error (error) {
                // GraphQL errors will not resolve on their own, so polling would only
                // repeat the same failing request. Network errors may be transient.
                if (error.graphQLErrors?.length) {
                    this.hasGraphQLError = true;
                    this.pollInterval = 0;
                }
                createAlert({
                    message: this.$options.i18n.pipelineSummaryFetchError
                });
                reportToSentry(this.$options.name, error);
            }
        }
    },
    computed: {
        commitPath () {
            return this.pipeline?.commit?.webPath;
        },
        commitSha () {
            return this.pipeline?.commit?.shortId;
        },
        downstreamPipelines () {
            return this.pipeline?.downstream?.nodes || [];
        },
        finishedAt () {
            return this.pipeline?.finishedAt;
        },
        isLoading () {
            return this.$apollo.queries.pipeline.loading;
        },
        pipelineId () {
            return getIdFromGraphQLId(this.pipeline?.id);
        },
        pipelinePath () {
            return this.status?.detailsPath || '';
        },
        pipelineStages () {
            return this.pipeline?.stages?.nodes || [];
        },
        status () {
            return this.pipeline?.detailedStatus || null;
        },
        statusLabel () {
            return this.status?.label || '';
        },
        upstreamPipeline () {
            return this.pipeline?.upstream || {};
        }
    },
    mounted () {
        Visibility.change(()=>{
            this.handlePolling();
        });
    },
    methods: {
        /** Note: cannot use `setupQueryPollingByVisibility` because interval is dynamic */ handlePolling () {
            if (!Visibility.hidden()) {
                this.resetPollInterval();
            } else {
                this.pollInterval = 0;
            }
        },
        increasePollInterval () {
            return getIncreasedPollInterval(this.pollInterval);
        },
        onJobActionExecuted () {
            this.resetPollInterval();
        },
        resetPollInterval () {
            if (this.hasGraphQLError) return;
            this.pollInterval = PIPELINE_POLL_INTERVAL_DEFAULT;
        }
    }
};
